export const emptyFunction = (): void => {
  // do nothing
};
